var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.5,
    fill: "#EEF3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 10.5,
    fill: "#41479B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    width: 10.5,
    height: 1.5,
    fill: "#DC251C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 3,
    width: 10.5,
    height: 1.5,
    fill: "#DC251C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 6,
    width: 10.5,
    height: 1.5,
    fill: "#DC251C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 9,
    width: 10.5,
    height: 1.5,
    fill: "#DC251C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 24,
    height: 1.5,
    fill: "#DC251C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 24,
    height: 1.5,
    fill: "#DC251C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 1.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 1.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 1.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 4.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 4.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 4.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 7.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 7.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 7.5,
    width: 1.5,
    height: 1.5,
    fill: "#C5D0EC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.590d8607.svg";
export { ForwardRef as ReactComponent };